import React, { useState, useEffect } from 'react'
import '../styles/Navbar.css'
import logo from '../assets/logo-nav.png'
import { useTranslation } from '../context/LanguageContext.jsx'
import { LanguageFlag } from './FlagIcons.jsx'

const LANG_ORDER = ['en', 'el', 'nl']

const Navbar = () => {
  const { t, language, setLanguage, dict } = useTranslation()
  const [isScrolled, setIsScrolled] = useState(false)
  const [isHidden, setIsHidden] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const langNames = dict.nav?.langNames ?? { en: 'English', el: 'Greek', nl: 'Dutch' }

  const cycleLanguage = () => {
    const i = LANG_ORDER.indexOf(language)
    const next = LANG_ORDER[(i + 1 + LANG_ORDER.length) % LANG_ORDER.length]
    setLanguage(next)
  }

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > 100) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHidden(true)
      } else {
        setIsHidden(false)
      }

      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-nav-open')
    } else {
      document.body.classList.remove('mobile-nav-open')
    }

    return () => {
      document.body.classList.remove('mobile-nav-open')
    }
  }, [isMobileMenuOpen])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <nav
      className={`navbar ${isScrolled ? 'scrolled' : ''} ${isHidden ? 'hidden' : ''} ${
        isMobileMenuOpen ? 'mobile-menu-open' : ''
      }`}
    >
      <div className="nav-content">
        <a href="#home" className="logo" onClick={closeMobileMenu} aria-label="Deverse — Home">
          <img src={logo} alt="" className="logo-image" />
        </a>

        <ul className="nav-links desktop-nav">
          <li>
            <a href="#home" onClick={closeMobileMenu}>
              {t('nav.home')}
            </a>
          </li>
          <li>
            <a href="#about" onClick={closeMobileMenu}>
              {t('nav.about')}
            </a>
          </li>
          <li>
            <a href="#services" onClick={closeMobileMenu}>
              {t('nav.services')}
            </a>
          </li>
          <li>
            <a href="#portfolio" onClick={closeMobileMenu}>
              {t('nav.projects')}
            </a>
          </li>
          <li>
            <a href="#demo" onClick={closeMobileMenu}>
              {t('nav.demo')}
            </a>
          </li>
          <li>
            <a href="#contact" onClick={closeMobileMenu}>
              {t('nav.contact')}
            </a>
          </li>
        </ul>

        <div className="nav-actions">
          <button
            type="button"
            className="lang-cycle-btn"
            onClick={cycleLanguage}
            aria-label={`${langNames[language] ?? language}. ${t('nav.chooseLanguage')}`}
            title={`${langNames[language] ?? language} — ${t('nav.chooseLanguage')}`}
          >
            <LanguageFlag code={language} className="lang-cycle-btn__flag" />
          </button>
          <button
            className={`burger-menu ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label={t('nav.menuToggle')}
            aria-expanded={isMobileMenuOpen}
            type="button"
          >
            <span className="burger-line"></span>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </button>
        </div>
      </div>

      <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
        <ul className="mobile-nav-links">
          <li>
            <a href="#home" onClick={closeMobileMenu}>
              {t('nav.home')}
            </a>
          </li>
          <li>
            <a href="#about" onClick={closeMobileMenu}>
              {t('nav.about')}
            </a>
          </li>
          <li>
            <a href="#services" onClick={closeMobileMenu}>
              {t('nav.services')}
            </a>
          </li>
          <li>
            <a href="#portfolio" onClick={closeMobileMenu}>
              {t('nav.projects')}
            </a>
          </li>
          <li>
            <a href="#demo" onClick={closeMobileMenu}>
              {t('nav.demo')}
            </a>
          </li>
          <li>
            <a href="#contact" onClick={closeMobileMenu}>
              {t('nav.contact')}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
